<template>
  <div class="">
    <Navbar />

    <div id="main">
      <div class="container">
        <div id="cover" class="row align-items-center">
          <div id="top" class="col-lg-4 col-md-5 col-sm-12">
            <h2 style="color:#fff; text-shadow: 1px 20px 50px white;">VOICE CASTING</h2>
          </div>
          <div class="col-lg-8 col-md-7 col-12">
            <img src="/logo/5c8223c182e1f_4kh2OdkJjy.jpg" style="width:100%;margin-top:-10px;">
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row">
          <div id="detail" style="min-height:200px; background: linear-gradient(#1b1b1b, #4e4e4e); color:#fff;">
            <div class="text-center mb-4">
              <h4>At IDIOM, we believe that creativity and imagination are fundamental elements in the casting process.
              </h4>
            </div>
            <div class="text-center" style="line-height: 1.8em; align:justify;">
              <small>Having cast numerous high-profile television and radio voiceover advertising campaigns, network promo
                voices, animated feature films, television series, and more, IDIOM offers access to the world's finest
                union and non-union voiceover talent.</small>
              <br><br>
              <small>Our offices in Los Angeles, Mumbai, Honolulu, and Bangkok deliver expert casting services, ensuring
                that nothing is left to chance when tight deadlines and budgets are at stake.</small>
              <br><br>
              <small>We are committed to maintaining the highest standards and firmly believe in our work philosophy. We
                arrange auditions at no cost and meticulously manage talent schedules during sessions.</small>
              <br><br>
              <small>If you require assistance in casting for your next project, please email us your scripts,
                specifications,
                budget, and due date, and we will take care of everything else.</small>
              <br><br>
              <h6>For more information, please don't hesitate to contact us at <a
                  href="mailto:casting@idiomtalent.com">casting@idiomtalent.com.&nbsp;</a>
              </h6>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Casting',
  components: { Navbar, Footer },
}
</script>

<style scoped>
/* #main { background-color:#aa4d8e !important; } */
#main {
  background-color: #894073 !important;
}

#cover {
  background: #050608 !important;
  height: 495px;
}

#top h2 {
  text-align: right;
}

#detail {
  padding: 50px;
}

#detail small {
  font-size: 16px;
}

@media (max-width: 600px) {
  #cover {
    min-height: 10px;
    max-height: 190px;
  }

  /* #top h2{ text-align:center; font-size:22px; } */
  #top {
    display: none;
  }

  #detail h4 {
    font-size: 18px;
  }

  #detail small {
    font-size: 14px;
  }

  #detail {
    padding: 25px;
  }
}
</style>
